import { CancelTokenSource } from 'axios';

import { QuickQuickSearchResponse } from '@/model';
import { QuickSearchResultWrapper } from '@/model/QuickSearchResultWrapper';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'quick-search';

export class QuickSearchController extends BaseHttpController {
  constructor() {
    super(endpoint, { useSelectedDomainContext: true });
  }

  async search(
    searchText: string,
    cancelToken?: CancelTokenSource,
  ): Promise<QuickSearchResultWrapper> {
    const response = await this.http.get<QuickSearchResultWrapper>(
      `${searchText}`,
      { cancelToken: cancelToken?.token },
    );
    return new QuickSearchResultWrapper(response.data);
  }

  async quickQuickSearch(
    query: string,
    cancelToken?: CancelTokenSource,
  ): Promise<QuickQuickSearchResponse> {
    const response = await this.http.get<QuickQuickSearchResponse>(
      'quickquick',
      {
        params: { query },
        cancelToken: cancelToken?.token,
      },
    );
    return new QuickQuickSearchResponse(response.data);
  }
}
